// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWaterColdIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 3c.36 0 .7.16.93.44C13.56 4.241 19 11.41 19 15c0 3.93-3.07 7-7 7s-7-3.07-7-7c0-3.6 5.44-10.769 6.07-11.56.23-.28.57-.44.93-.44m0 9.02c-.28 0-.5.22-.5.5v2.13l-1.85-1.07a.494.494 0 0 0-.68.18c-.14.24-.06.54.18.68L11 15.51l-1.85 1.07c-.24.14-.32.44-.18.68a.496.496 0 0 0 .68.18l1.85-1.07v2.13c0 .28.22.5.5.5s.5-.22.5-.5v-2.13l1.85 1.07a.496.496 0 0 0 .68-.18c.14-.24.06-.54-.18-.68L13 15.51l1.85-1.07c.24-.14.32-.44.18-.68a.494.494 0 0 0-.68-.18l-1.85 1.07v-2.13c0-.28-.22-.5-.5-.5"
      clipRule="evenodd"
    />
  </g>
);
export default SvgWaterColdIcon;
SvgWaterColdIcon.displayName = 'SvgWaterColdIcon';
